import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.min.css';

export const CustomAlert = (msg, type) => {
    toast(msg, { position: "bottom-right", autoClose: 5000, type: type });
}

